import React from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { Counterparty } from "@common/types/counterparty";
import { getCounterpartyCreatedByLabel } from "@common/helpers/counterparties";
import { CounterpartyDirectoryViewRow } from "../counterpartyDirectoryViewTypes";
import styles from "../DirectoryTable.module.scss";

export const CounterpartySourceCell: React.FC<
    CellContext<
        ViewTableFeatures,
        CounterpartyDirectoryViewRow,
        Counterparty | null
    >
> = React.memo(({ row }) => {
    if (row.original.isAccountRow) {
        return <ViewTableCell />;
    }

    const { counterparty } = row.original;

    if (!counterparty) {
        return <ViewTableCell />;
    }

    return (
        <ViewTableCell>
            <div className={styles.sourceLabel}>
                {getCounterpartyCreatedByLabel(counterparty)}
            </div>
        </ViewTableCell>
    );
});

CounterpartySourceCell.displayName = "CounterpartySourceCell";
